import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StripeScriptTag, StripeSource } from "stripe-angular";
import { StripeToken } from "stripe-angular";
import { url } from '../../../../shared/urls/url';
import { retry, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { getLocaleDateTimeFormat } from '@angular/common';
import { DATE } from 'ngx-bootstrap/chronos/units/constants';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  public show: boolean = false;
  public email;
  public phone;
  public company;
  public pass;
  public plan;
  public uid;
  public nombreplan;
  public precio;
  private publishableKey: string = "pk_test_5DSwR9mjzzhnUxEaX2BSg5v1";
  extraData = {
    "name": null,
    "address_line1": null,
    "address_line2": null
  }

  constructor(private user: url, private http: HttpClient, public StripeScriptTag: StripeScriptTag, private rutaActiva: ActivatedRoute, private router: Router) {


    this.StripeScriptTag.setPublishableKey(this.publishableKey);
    this.email = this.rutaActiva.snapshot.params.email;
    this.plan = this.rutaActiva.snapshot.params.plan;
    this.uid = this.rutaActiva.snapshot.params.uid;
    this.extraData.name = this.rutaActiva.snapshot.params.name;
    const url1 = this.user.apiphp + "?consultarplanporproducto=" + this.plan;

    this.http.get(url1, { responseType: 'text' }).subscribe(x => {
      var cadena = x.replace("Missing required param: source.", '');
      var arre = JSON.parse(cadena);
      this.nombreplan = arre.nickname;
      this.precio = arre.amount / 100;
    })
  }


  ngOnInit() {


  }


  onStripeInvalid(error: Error) {
    console.log('Validation Error', error);
    
  }
 
  setStripeToken( token:StripeToken ){
    try{
    const url1 = this.user.apiphp+"?source="+token.id+"&email="+this.email+"&description="+this.extraData.name+"&miplan="+this.plan+"&company="+this.company+"&phone="+this.phone+"&uid="+this.uid;
    console.log(url1);
    this.http.get(url1,{responseType:'text'}).subscribe(xy=>{ 
      console.log(xy);
       var j=JSON.parse(xy.toString()); 
       const data = {
        idcustomer: j.cliente,
        idmembresiastripe: j.membresia,
        googleuid: this.uid
      };
  
       const url2 = this.user.apiback+'/register';
       this.http.post(url2, data).subscribe(y=>{ 
        var w=JSON.stringify(y); 
        var oj = JSON.parse(w);
           console.log(oj);
           var cant = 0;
           if(this.plan=="prod_FajU2nM1pXOK54")
              cant=5;
              else 
                if(this.plan=="prod_FajVdrsp2WopZ7")
                  cant=15;
                  else
                  if(this.plan=="prod_FajWVi7MZtItp2")
                    cant=50;
                  else 
                  if(this.plan=="prod_FnVRuUlWY9Feyl")
                     cant=100;
                     const dataX = 
                     {
                       IDCuenta: oj.cuenta.idCuenta,
                       Verificaciones: cant,
                     }
                     const url3 = this.user.apiback+"/registerPackCuenta";
                     this.http.post(url3, dataX).subscribe(y=>{ 
                      var w=JSON.stringify(y); 
                      var oj = JSON.parse(w);
                      this.router.navigate(['/agradecimiento','Gracias por adquirir el Plan',this.nombreplan]);
                     });
                    /* const url2 = this.user.apiback+"/registerPackCuenta?idcuenta="+oj.cuenta.idCuenta+"&num="+cant;
                     console.log(url2);
                     this.http.get(url2, {responseType: 'text'}).subscribe(z=>{ 
                      var jm=JSON.parse(z); 
                      console.log(jm);
                      this.router.navigate(['/agradecimiento','Gracias por adquirir el Plan',this.nombreplan]);   
                    })  */            
           })  
     })
  }
  catch(e)
  {
    console.log("error="+e.message);
  }
}

 /* setStripeToken(token: StripeToken) {
    try {
      const url1 = this.user.apiphp + "?source=" + token.id + "&email=" + this.email + "&description=" + this.extraData.name + "&miplan=" + this.plan + "&company=" + this.company + "&phone=" + this.phone + "&uid=" + this.uid;
      console.log(url1);
      this.http.get(url1, { responseType: 'text' }).subscribe(xy => {
        console.log(xy);
        var j = JSON.parse(xy.toString());
        const data = {
          idcustomer: j.cliente,
          idmembresiastripe: j.membresia,
          googleuid: this.uid
        };

        const url2 = this.user.apiback + '/register';
        this.http.post(url2, data).subscribe(y => {
          var w = JSON.stringify(y);
          var oj = JSON.parse(w);
          console.log(oj);
          var cant = 0;
          if (this.plan == "prod_FajU2nM1pXOK54")
            cant = 5;
          else
            if (this.plan == "prod_FajU2nM1pXOK54")
              cant = 15;
            else
              if (this.plan == "prod_FajU2nM1pXOK54")
                cant = 50;
              else
                if (this.plan == "prod_FajU2nM1pXOK54")
                  cant = 100;

          const url2 = this.user.apiback + "/registerPackCuenta?idcuenta=" + oj.cuenta.idCuenta + "&num=" + cant;
          console.log(url2);
          this.http.get(url2, { responseType: 'text' }).subscribe(z => {
            var jm = JSON.parse(z);
            console.log(jm);
            this.router.navigate(['/agradecimiento', 'Gracias por adquirir el Plan', this.nombreplan]);
          })
        })
      })
    }
    catch (e) {
      console.log("error=" + e.message);
    }

  }*/

  setStripeSource(source: StripeSource) {
    console.log('Stripe source', source);
  }

  onStripeError(error: Error) {
    console.error('Stripe error', error);
  }

}
